import PropTypes from 'prop-types'

import './index.scss'

import cn from '@/utilities/cn'

const Footer = ({ children, className }: any) => <div className={cn('card__footer', className)}>{children}</div>

Footer.displayName = 'Footer'

Footer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
}

Footer.defaultProps = {
  children: null,
  className: ''
}

export default Footer
